'use client';

import { cn } from '@/lib/tailwind';
import UiLogo from '@/components/ui/UiLogo';
import { useScrolled } from '@/hooks';
import Link from 'next/link';
import { NavigationMain } from '@/features/navigation';

interface HeaderProps {
    className?: string;
}

function Header({ className }: HeaderProps = {}) {
    const isScrolled = useScrolled();

    return (
        <header
            className={cn(
                '@container sticky inset-x-0 top-0 z-50',
                'flex flex-col justify-center',
                'py-3 h-17 lg:h-20',
                'border-b border-white/30  transition-colors duration-300',
                isScrolled && 'bg-body-secondary border-0',
                className,
            )}
        >
            <div className="mx-auto w-full max-w-page-md px-gutter">
                <div className="grid grid-cols-2 gap-6 items-center @min-[64rem]:grid-cols-3">
                    <div className="flex items-center">
                        <Link href="/" aria-label="Homepage" className="inline-block">
                            <UiLogo variant="emblem" className="size-12 @min-[64rem]:size-15" eager />
                        </Link>
                    </div>

                    <UiLogo variant="wordmark" className="w-full max-w-22 mx-auto hidden @min-[64rem]:block" eager />

                    <NavigationMain />
                </div>
            </div>
        </header>
    );
}

export default Header;
